// Modules
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store';
import UITimer from '../../components/ui-timer';
import UIFlexBox from '../../components/flex/flex-box';
import '../../css/beer.css';

export default function LobbyStarting() {
//class LobbyStarting extends React.Component {

	const lobby = useSelector((state:RootState) => state.page.lobby);
	const translate = useSelector((state:RootState) => state.ui.language.lobby.starting);
	let tips:React.JSX.Element[] = [];

	if(translate.tips && translate.tips.length > 0) {
		translate.tips.forEach( (v, i) => {
			tips.push(<div key={i}><i style={{width: "100%"}}>{v}</i></div>);
		});
	}
	
	return(
		<UIFlexBox backHeader={{ title: "", enabled: false }}>
			<div style={{position: 'relative'}}>
				<div id="glass">
					<div id="beer"></div>
				</div>
				<div id="poignet"></div>
				<div id="mousse_1"></div>
				<div id="mousse_2"></div>
				<div id="mousse_3"></div>
				<div id="mousse_4"></div>
				<div id="mousse_5"></div>
				<div id="mousse_volante"></div>
				<div id="mousse_interieur"></div>
				<div id="mousse_interieur_2"></div>
				<div id="mousse_interieur_3"></div>
				<div id="mousse_interieur_4"></div>
			</div>
			<div>{tips}</div>
			<UITimer seconds={lobby.timeleft} reverse={true} message="Getting some cold ones from the fridge..." />
		</UIFlexBox>
	);
}

